<template>
  <div v-if="formType.code === 'MPSC'">
    <FormPregrado />
  </div>
  <div v-else>
      <div v-if="formType.code === 'MS'">
        <FormSecundario />
      </div>
  </div>
</template>

<script>
import FormPregrado from "../components/FormPregrado";
import FormSecundario from "../components/FormSecundario";
import FormSecundarioExamen from "../components/FormSecundarioExamen";
import formTypesMap from "../utils/formTypesMap"

export default {
  components: {
    FormPregrado,
    FormSecundario,
    FormSecundarioExamen,
  },
  mounted() {
    this.formType.code = formTypesMap[this.$route.params.call.form_type.type];
  },
  data() {
    return {
      formType: {
        code: "",
      },
    };
  },
  methods: {
  }
};
</script>
